<template>
  <div class="flex flex-col w-full px-6 mt-5">
    <base-button variant="bordered-error" class="w-full" @click="removeEmailBubble">
      Remove email
    </base-button>
  </div>
</template>

<script>
import stateTreeUtils from '@/utils/state-tree.utils'
import templateModule from '@/store/modules/template.module'
import templateController from '@/controllers/template.controller'
import answerController from '@/controllers/answer.controller'
import chatBubbleModule from '@/store/modules/chat-bubble.module'

export default {
  name: 'EmailEditor',

  computed: {
    bubbleSelected: chatBubbleModule.bubbleSelected,
    stateTree: chatBubbleModule.stateTree,

    previewController() {
      return templateModule.isTemplateEditor() ? templateController : answerController
    }
  },

  methods: {
    removeEmailBubble() {
      const node = stateTreeUtils.findNode(this.stateTree, this.bubbleSelected)
      this.previewController.removeBubble(node, templateModule.getTemplateId())
    }
  }
}
</script>
